/**
 * SEO text helpers.
 *
 * `truncateDescription` produces a search-engine-safe meta description:
 * ≤155 chars, word-boundary truncated, with an ellipsis. Google typically
 * displays ~155–160 chars on desktop before cutting off, so anything longer
 * is flagged as "Meta Description Too Long" by SEO crawlers.
 */
export function truncateDescription(input: string | null | undefined, max = 155): string {
  if (!input) return "";
  const s = String(input).replace(/\s+/g, " ").trim();
  if (s.length <= max) return s;
  const cut = s.slice(0, max - 1);
  const lastSpace = cut.lastIndexOf(" ");
  const base = lastSpace > 40 ? cut.slice(0, lastSpace) : cut;
  return base.replace(/[.,;:!?\-]+$/, "") + "…";
}
